import { Navigate, useLocation } from 'react-router-dom';
import { ADMIN_HOME, legacyAdminUrl } from '../../lib/adminRoutes';

/**
 * `/admin` — l'ingresso dell'Amministrazione.
 *
 * Dal 24/09/2026 l'Amministrazione non è più una pagina con nove tab ma sei
 * pagine vere (Situazione, Fatture, Spese, Fisco, Dipendenti, Banca: vedi
 * lib/adminRoutes.ts e le cartelle qui accanto). Questo componente fa solo due
 * cose:
 *   · un vecchio indirizzo `/admin?tab=…` va al suo posto nuovo, con i
 *     parametri tradotti (per sempre: le notifiche salvate nel database hanno
 *     ancora quei link);
 *   · altrimenti porta alla prima pagina: dal 16/10/2026 il Calendario dei
 *     pagamenti (la Situazione resta su /admin/situazione, fuori dal menu).
 */
export function AdminPage() {
  const { search } = useLocation();
  const legacy = legacyAdminUrl(search);
  if (legacy) return <Navigate to={legacy} replace />;
  return <Navigate to={ADMIN_HOME} replace />;
}
